import { Skeleton, Stack, useMediaQuery, useTheme } from "@mui/material";
// import { formatCount } from "../../utils/utils";
import StatTile from "../../components/StatTile";

export default function TVSeriesJournalSummary({ summary, isLoading }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isLoading || !summary) {
    return <Skeleton variant="rectangular" width="100%" height={100} />;
  }

  const {
    total_seasons,
    status_counts,
    seasons_rated,
    average_rating,
    has_activity,
  } = summary;

  if (!has_activity) return null;

  // const finishedCount = status_counts?.finished ?? 0;
  // const seasonsLeft = Math.max(total_seasons - finishedCount, 0);

  // const finishedPercentage =
  //   total_seasons > 0 ? Math.round((finishedCount / total_seasons) * 100) : 0;

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="stretch" // is there a way i can make each stat tile take up the height of the tallest one?
      sx={{ mb: 1 }}
    >
      <StatTile
        count={status_counts["finished"]}
        label={<>seasons {isMobile && <br />} finished</>}
        outOf={total_seasons}
      />
      {status_counts["queued"] > 0 && (
        <StatTile
          count={status_counts["queued"]}
          label={
            status_counts["queued"] === 1 ? (
              <>season {isMobile && <br />} queued</>
            ) : (
              <>seasons {isMobile && <br />} queued</>
            )
          }
        />
      )}

      <StatTile
        count={seasons_rated}
        label={
          seasons_rated === 1 ? (
            <>season {isMobile && <br />} rated</>
          ) : (
            <>seasons {isMobile && <br />} rated</>
          )
        }
      />
      <StatTile
        count={average_rating ? average_rating.toFixed(1) : "—"}
        label={<>avg. season {isMobile && <br />} rating</>}
      />
    </Stack>
  );
}
